import {
    ValidationError,
    setLocale,
    ObjectSchema,
    Schema,
    StringSchema,
    object,
    string,
    addMethod,
    number,
    mixed,
} from 'yup';
import { locale } from './yup-locale';
setLocale(locale);

import { mapErrors, getValidationErrors } from './custom-functions';
import './custom-method';

export {
    number,
    mixed,
    ObjectSchema,
    Schema,
    ValidationError,
    StringSchema,
    getValidationErrors,
    mapErrors,
    object,
    string,
    addMethod,
};

export interface UIValidationError {
    message: string;
    params?: Record<string, any>;
    errors?: string[];
}

export type ValidationErrorMap = Record<string, UIValidationError>;
